(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-type="collection"]');
    if (!section || section.dataset.clyroBound === '1') return;
    section.dataset.clyroBound = '1';

    // Filter dialog (mobile) — open / close via [data-clyro-filter-open/close].
    var dialog = section.querySelector('.clyro-collection__filter-dialog');
    if (dialog) {
      section.querySelectorAll('[data-clyro-filter-open]').forEach(function (b) {
        b.addEventListener('click', function () { dialog.showModal && dialog.showModal(); });
      });
      section.querySelectorAll('[data-clyro-filter-close]').forEach(function (b) {
        b.addEventListener('click', function () { dialog.close && dialog.close(); });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    // Auto-submit the filter form whenever a checkbox / radio / number changes.
    // Debounced for number inputs so typing a price range doesn't fire mid-key.
    var forms = section.querySelectorAll('[data-clyro-filter-form]');
    forms.forEach(function (form) {
      var t = null;
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-clyro-facet]')) return;
        if (e.target.type === 'number') {
          if (t) clearTimeout(t);
          t = setTimeout(function () { form.submit(); }, 600);
        } else {
          form.submit();
        }
      });
    });

    // Top sort dropdown — submits via location.search so query params stay
    // independent from the filter form.
    var topSort = section.querySelector('.clyro-collection__sort');
    if (topSort) {
      topSort.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', topSort.value);
        window.location.search = params.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHpGallery(root) {
      var g = (root || document).querySelector('[data-hp-gallery]');
      if (!g || g._hpInit) return;
      g._hpInit = true;
      var stage = g.querySelector('[data-hp-stage]');
      if (!stage) return;
      var slides = stage.querySelectorAll('[data-hp-slide]');
      var thumbs = g.querySelectorAll('[data-hp-thumb]');

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-hp-index'), 10) || 0;
          var slide = slides[i];
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        });
      });

      stage.addEventListener('scroll', function () {
        var idx = Math.round(stage.scrollLeft / stage.clientWidth);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    document.addEventListener('DOMContentLoaded', function () { initHpGallery(document); });
    document.addEventListener('shopify:section:load', function (e) { initHpGallery(e.target); });
    if (document.readyState !== 'loading') initHpGallery(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyBar(root) {
      var bar = (root || document).querySelector('[data-sticky-buy-bar]');
      if (!bar || bar._sbbInit) return;
      bar._sbbInit = true;
      bar.classList.add('is-enabled');

      var offer = document.getElementById('offer');
      var scrolledPastHero = false;

      function getHeroBottom() {
        var hero = document.querySelector('[data-section-type="hero-dark"], [data-section-type="hero-product"]');
        if (!hero) return window.innerHeight * 0.6;
        return hero.getBoundingClientRect().bottom + window.scrollY;
      }

      function update() {
        var heroBottom = getHeroBottom();
        scrolledPastHero = window.scrollY > heroBottom;

        var offerVisible = false;
        if (offer) {
          var r = offer.getBoundingClientRect();
          offerVisible = r.top < window.innerHeight && r.bottom > 0;
        }

        if (scrolledPastHero && !offerVisible) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    document.addEventListener('DOMContentLoaded', function () { initStickyBar(document); });
    document.addEventListener('shopify:section:load', function (e) { initStickyBar(e.target); });
    if (document.readyState !== 'loading') initStickyBar(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
